import { mapState, mapActions, mapMutations } from "vuex"
import localStorageApi from '@/utils/localStorageUtils'
export const commonData = {
	props: ['bigtitle', 'smalltitle'],
	data() {
		return {
			ossUrl: 'https://oss.sbooip.com',
			windowheight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
			loadingsw: false,
			showempty: false,
			isPreviewVisible: false,
			empytTips: '~O(∩_∩)O~ 抱歉，暂无记录！',
			loadingtext: '拼命加载中请稍后...',
		}
	},
	computed: {
		// 获取store中的数据,mapStates数组写法
		...mapState('home', ['activeRoute',
			'expiredCount',
			'luckyCount',
			'imgArr',
			'queryCount',
			'consumeCount',
			'waDatas',
			'annualCount',
			'wxData',
			'autoUpCount',
			'noteCount',
			'wxDatas']),
		// 计算属性判断是否在详情页,用于隐藏和显示轮播图
		isDetil() {
			if (this.$route.path.includes('CaseDetails')
				|| this.$route.path.includes('OADetailes')
				|| this.$route.path.includes('middleCaseDetials')
				|| this.$route.path.includes('TrademarkDetails')
				|| this.$route.path.includes('TMmiddleDectail')
				|| this.$route.path.includes('TCopyRightDetails')
				|| this.$route.path.includes('TMoaDetails')
				|| this.$route.path.includes('BanquanCopywritDetials')
				|| this.$route.path.includes('BanquanRegistDetails')
				|| this.$route.path.includes('CopyRightDetails')) {
				return true
			}
		}
	},
	methods: {
		//借助mapActions生成对应的方法
		...mapActions('home', ['getGlobalInfos', 'getUserInofo', 'getCountData']),
		//借助mapActions生成对应的方法
		...mapMutations('home', ['SETACTIVE', 'SETUSERINFO', 'LOGOUT', 'SETLUCKYCOIN', 'SETBANNER', 'SETCOMPANY']),
		// 更新路由
		formatMetaTitles() {
			const titles = this.$route.matched.map(record => record.meta.title);
			return titles.join(' / ');
		},
		updateActiveRoute(routeName) {
			switch (routeName) {
				case 'Index': // 首页
					this.SETACTIVE(0);
					break;
				case 'About': // 关于我们
				case 'Company':
				case 'History':
				case 'Qualification':
				case 'CooperativeClients':
				case 'CaseShowcase':
				case 'TalentRecruitment':
					this.SETACTIVE(1);
					break;
				case 'Trademark': // 商标注册
				case 'SearchDesign':
				case 'Renewal':
				case 'NonCancellation':
				case 'AnswerReview':
				case 'Surveillance':
					this.SETACTIVE(2);
					break;
				case 'Patent': // 专利申请
				case 'SearchWrite':
				case 'InvalidationResponse':
				case 'TransferLicense':
				case 'FastTrackExamination':
				case 'Planning':
					this.SETACTIVE(3);
					break;
				case 'Copyright': // 版权登记
				case 'Registration':
				case 'RightsProtection':
					this.SETACTIVE(4);
					break;
				case 'knowledge': // 知产维权
				case 'InventionPatent':
				case 'UtilityPatent':
				case 'DesignPatent':
				case 'GoodsTrademark':
				case 'ServiceMark':
				case 'CopyrightRights':
					this.SETACTIVE(5);
					break;
				case 'IndustryNews': // 行业动态
				case 'AllNews':
				case 'NewsDetail-AllNews':
				case 'SectorNews':
				case 'NewsDetail-SectorNews':
				case 'CompanyNews':
				case 'NewsDetail-CompanyNews':
				case 'KnowledgeSharing':
				case 'NewsDetail-KnowledgeSharing':
				case 'ProoUse':	
					this.SETACTIVE(6);
					break;
				case 'Contact': // 联系顾问
					this.SETACTIVE(7);
					break;
				case 'BigData': // 大数据
				case 'Attachment':
				case 'ProxyCenter':
				case 'BiPatentSearchgData':
				case 'WaitSync':
				case 'Normal':
				case 'Expire':
				case 'Lose':
				case 'Recycle':
				case 'AutoUpdate':
				case 'My':
					this.SETACTIVE(8);
					break;
			}
		},
		// 下载文件
		async downloadFiles(fileUrl, suffix, name) {
			try {
				// 使用 fetch API 发起请求获取图片，设置 mode 为 no-cors
				const response = await fetch(fileUrl, { mode: 'no-cors' });
				// 获取响应的二进制数据
				const blob = await response.blob();
				// 创建一个 <a> 元素
				const a = document.createElement('a');
				// 创建一个指向二进制数据的 URL
				const url = window.URL.createObjectURL(blob);
				// 设置 <a> 元素的 href 属性为二进制数据的 URL
				a.href = url;
				// 设置 <a> 元素的 download 属性，指定下载文件的名称
				a.download = name + '.' + suffix;
				// 将 <a> 元素添加到文档中
				document.body.appendChild(a);
				// 模拟点击 <a> 元素来触发下载
				a.click();
				// 下载完成后，将 <a> 元素从文档中移除
				document.body.removeChild(a);
				// 释放二进制数据的 URL
				window.URL.revokeObjectURL(url);
			} catch (error) {
				// 若请求过程中出现错误，打印错误信息
				console.error('下载出错:', error);
			}
		},
	},
	
}

